<div class="general-container" *ngIf="step === 0" [ngClass]="{'mob-general': isMobileApp !== undefined}">
    <fun-overal-message [idG]="idG" [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="finish()"></fun-overal-message>
    <div class="register">
        <div class="span-container">
            <span id="page-title" *ngIf="status === 0">Registro finalizado: perfil incompleto</span>
            <span id="page-title" *ngIf="status === 1">Registro finalizado: perfil completo</span>
        </div>
    </div>
</div>